module.exports = __webpack_public_path__ + "img/logo-admin.34301c33.png";